import type { NavigableRouteType } from '@/router/types';

export const signIn = {
  path: '/sign-in',
  description: 'The sign in page.',
  navigable: true,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signInEmail = {
  path: '/sign-in/email',
  description: 'The email sign in page.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signInSso = {
  path: '/sign-in/sso',
  description: 'The SSO email sign in page.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signInDiscovery = {
  path: '/sign-in/discovery',
  description: 'Shows organizations the user can sign in to.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signInPassword = {
  path: '/sign-in/password',
  description: 'The password sign in page.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signInPasswordForgot = {
  path: '/sign-in/password/forgot',
  description: 'The forgot password page for discovery flow.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signUp = {
  path: '/sign-up',
  description: 'The sign up page.',
  navigable: true,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signUpEmail = {
  path: '/sign-up/email',
  description: 'The email sign up page.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const configureOrg = {
  path: '/sign-up/configure-org',
  description: 'The configure organization page.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const signInInst = {
  path: '/sign-in/inst/:orgSlug',
  description: 'Tenant-specific sign in page.',
  navigable: false,
  pathParams: {
    orgSlug: {
      type: 'string',
      description: 'The organization slug (without inst~ prefix)',
      required: true,
    },
  },
  searchParams: {},
} satisfies NavigableRouteType;

export const signInInstEmail = {
  path: '/sign-in/inst/:orgSlug/email',
  description: 'Tenant-specific email sign in page.',
  navigable: false,
  pathParams: {
    orgSlug: {
      type: 'string',
      description: 'The organization slug (without inst~ prefix)',
      required: true,
    },
  },
  searchParams: {},
} satisfies NavigableRouteType;

export const signInInstPassword = {
  path: '/sign-in/inst/:orgSlug/password',
  description: 'Tenant-specific password sign in page.',
  navigable: false,
  pathParams: {
    orgSlug: {
      type: 'string',
      description: 'The organization slug (without inst~ prefix)',
      required: true,
    },
  },
  searchParams: {},
} satisfies NavigableRouteType;

export const signInInstPasswordForgot = {
  path: '/sign-in/inst/:orgSlug/password/forgot',
  description: 'Tenant-specific forgot password page.',
  navigable: false,
  pathParams: {
    orgSlug: {
      type: 'string',
      description: 'The organization slug (without inst~ prefix)',
      required: true,
    },
  },
  searchParams: {},
} satisfies NavigableRouteType;

export const oauth = {
  path: '/oauth/authorize',
  description: 'The OAuth authorization page.',
  navigable: false,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

/**
 * Build a path to the tenant-specific sign-in page.
 * @param slug - The organization slug (with or without inst~ prefix)
 * @param searchParams - Optional search params to append (e.g., Stytch token params)
 */
export const signInInstanceBySlug = (slug: string, searchParams?: URLSearchParams) => {
  const orgSlug = slug.replace(/^inst~/, '');
  const query = searchParams?.toString();
  return query ? `/sign-in/inst/${orgSlug}?${query}` : `/sign-in/inst/${orgSlug}`;
};

export const signInInstancePasswordBySlug = (slug: string, searchParams?: URLSearchParams) => {
  const orgSlug = slug.replace(/^inst~/, '');
  const query = searchParams?.toString();
  return query ? `/sign-in/inst/${orgSlug}/password?${query}` : `/sign-in/inst/${orgSlug}/password`;
};
